import { INITIAL_WORKS } from '../data/defaultWorks';

// Versioned on purpose. v1 seeded the stock catalogue into every visitor's
// browser and then served the stored copy forever, so no deploy could ever
// replace it. Bump this whenever the seed changes shape or content.
const STORAGE_KEY = 'handmadebee_works_v3';

export const storageService = {
  // Get all works (combines local storage with initial default catalog)
  getWorks: () => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored) {
        return JSON.parse(stored);
      }
      // Initialize with default catalog if first time
      localStorage.setItem(STORAGE_KEY, JSON.stringify(INITIAL_WORKS));
      return INITIAL_WORKS;
    } catch (err) {
      console.error('Failed to read from localStorage:', err);
      return INITIAL_WORKS;
    }
  },

  // Save new work
  saveWork: (newWork) => {
    try {
      const current = storageService.getWorks();
      const workItem = {
        ...newWork,
        id: newWork.id || `work-${Date.now()}`,
        createdAt: new Date().toISOString(),
      };
      const updated = [workItem, ...current];
      localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
      return workItem;
    } catch (err) {
      console.error('Failed to save work:', err);
      throw err;
    }
  },

  // Update existing work
  updateWork: (id, updates) => {
    try {
      const current = storageService.getWorks();
      const updated = current.map(item => item.id === id ? { ...item, ...updates } : item);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
      return updated.find(item => item.id === id);
    } catch (err) {
      console.error('Failed to update work:', err);
      throw err;
    }
  },

  // Delete work
  deleteWork: (id) => {
    try {
      const current = storageService.getWorks();
      const updated = current.filter(item => item.id !== id);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
      return true;
    } catch (err) {
      console.error('Failed to delete work:', err);
      throw err;
    }
  },

  // Reset to original demo showcase
  resetToDefaults: () => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(INITIAL_WORKS));
    return INITIAL_WORKS;
  }
};
